import { Typography } from "@mui/material"

export default function Condicional({
    resposta
}: CondicionalProps) {
    return (
        <>
            {resposta && <Typography variant="caption">Resposta: <b>{resposta}</b></Typography>}
        </>
    )
}

interface CondicionalProps {
    resposta?: string
}